import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUserArrowRight = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.26699 14H4.00033C3.26395 14 2.66699 13.403 2.66699 12.6667C2.66699 11.1939 3.8609 10 5.33366 10H8.26699M12.7926 10C13.4506 10.4935 14.0448 11.066 14.5621 11.7043C14.632 11.7906 14.667 11.8953 14.667 12C14.667 12.1047 14.632 12.2094 14.5621 12.2957C14.0448 12.934 13.4506 13.5065 12.7926 14M14.667 12H10.0003M10.667 4.66667C10.667 6.13943 9.47308 7.33333 8.00033 7.33333C6.52757 7.33333 5.33366 6.13943 5.33366 4.66667C5.33366 3.19391 6.52757 2 8.00033 2C9.47308 2 10.667 3.19391 10.667 4.66667Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgUserArrowRight);
export default ForwardRef;
